@defer{
    <div appDynamicScale style="position: fixed; width: 100vw; height:100vh; top:0; left:0;">
        <router-outlet></router-outlet>
    </div>
} @placeholder {
    <div></div>
}
